// extracted by mini-css-extract-plugin
export default {"boxShadow":"login_boxShadow__oONpj","labelBox":"login_labelBox__gEdnE","error":"login_error__Cse+h","inputs":"login_inputs__1uUGH","checkBox":"login_checkBox__bbCDx"};